/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/View',
	'underscore'
], function(View, _) {

	var Separator = null;

	/**
	 * Represents a separator  that can be added to an app bar
	 */
	Separator = View.extend({
		events: { 'click': 'action' },
		baseClass: 'toolbar',

		/**
		 * Creates a separator
		 */
		init: function(spec) {
			_.extend(this, spec);
			Separator.inherited('init', this, arguments);
		},

		/**
		 * Draws the separator
		 */
		render: function() {
			this.$el.empty();
			this.$el.addClass(this.baseClass + 'SeparatorItem');
			this.$el.attr('role', 'presentation');
			return this;
		}


	});

	return Separator;
});
